const React = require('react');
const noop = require("mn-utils/noop");

const {PAYMENT_METHODS} = require('../../../../../../constants/paymentMethods/');
const {DisplayAmountAdmin, DisplayIdAdmin, DisplayDateTimeAdmin, DisplayDataAdmin} = require('../../../../../dumb/DisplayData');

const {AdminTableRow} = require('../../../../TableRow');
const {HeadCellAdmin} = require("../../../../TableHeadCell/components/HeadCellAdmin");
const {AdminCheckbox} = require("../../../../FormInputs");


module.exports = ({data, selected = [], setSelected = noop, index}) => {
  const {
    id,
    old_transaction_lifeflow = '',
    old_payment_invoice_lifeflow,
    new_transaction_lifeflow = '',
    lifeflow = '',
    payment_invoice = {}
  } = data;

  const {
    source_asset,
    source_amount,
    created_at,
    payment_method,
    account = {},
  } = payment_invoice;

  const paymentMethod = (PAYMENT_METHODS[payment_method] || {}).name;

  return (
    <AdminTableRow className="f12" onClick={false} index={index}>
      <div className="wmin40 fx1">
        <AdminCheckbox
          value={selected.includes(id)}
          onChange={(name, val) => {
            const nextState = val
              ? [...selected, id]
              : selected.filter((el) => el !== id);

            setSelected(nextState);
          }}
        />
      </div>
      <div className="wmin185 fx1 bold">
        <DisplayIdAdmin>{id}</DisplayIdAdmin>
      </div>
      <div className="wmin185 fx1 bold">
        <DisplayDataAdmin>{account.name}</DisplayDataAdmin>
        <DisplayDataAdmin className="mt3 lh16 fw4 c717275">{account.login}</DisplayDataAdmin>
      </div>
      <div className="wmin185 fx1">
        <DisplayDateTimeAdmin date={created_at} />
      </div>
      <div className="wmin185 fx1">
        <DisplayAmountAdmin
          amount={source_amount}
          symbol={source_asset}
          type="fiat"
        />
      </div>
      <div className="wmin185 fx1 bold">
        <DisplayDataAdmin>{paymentMethod}</DisplayDataAdmin>
      </div>
      <div className="wmin200">
        {old_transaction_lifeflow.toUpperCase()} / {old_payment_invoice_lifeflow.toUpperCase()}
      </div>
      <div className="wmin150">
        {new_transaction_lifeflow.toUpperCase()}
      </div>
      <div className="wmin150">
        {lifeflow.toUpperCase()}
      </div>
    </AdminTableRow>
  );
};
